import { makeVar } from '@apollo/client/core';
import type SnackVariableInterface from '../../../Interface/SnackVariableInterface';

export const snackBarVar = makeVar<SnackVariableInterface>({
  isOpen: false,
  message: undefined,
  type: 'SUCCESS',
  duration: 5000,
});
